import { createSlice } from '@reduxjs/toolkit'

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    posts: [],
  },
  reducers: {
    updatePosts: (state, action) => {
      if (action.payload.length === 0) {
        state.posts = [];
      } else {
        for (let i = 0; i < action.payload.length; i++) {
          if (!state.posts.includes(action.payload[i])) {
            state.posts = state.posts.concat(action.payload[i]);
          }
        }
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  updatePosts,
} = appSlice.actions

export default appSlice.reducer
